<template>
  <div ref="formRoot" class="container main--sticky-bottom">
    <el-collapse v-model="activeCollapseIndexes">
      <el-collapse-item
        v-for="(contact, index) in contacts"
        :key="contact.contactID"
        :name="index"
        class="el-collapse-item--dietary"
      >
        <!--<div class="label-mandatory">fields with <span class="indicator-mandatory">*</span> are mandatory</div>-->
        <template slot="title" class="title">
          <span class="guest-number">GUEST {{ index + 1 }}/</span
          >{{ getFullName(contact) }}
        </template>
        <el-form
          :ref="'formValidate' + contact.contactID"
          :model="contact"
          :rules="ruleValidate"
          label-position="left"
          label-width="204px"
          hide-required-asterisk
        >
          <div class="guest-helper">Fields marked with * are mandatory</div>
          <!--          <el-form-item-->
          <!--            label="Dietary restrictions*"-->
          <!--            prop="dietaryPreferences"-->
          <!--            v-if="canShowDietaryPreferenceField()"-->
          <!--          >-->
          <!--            <v-select-->
          <!--              v-model="modelSelectedDietaryPreferences[contact.contactID]"-->
          <!--              :options="selectDietaryPreferences"-->
          <!--              :reduce="(item) => item.value"-->
          <!--              :searchable="false"-->
          <!--              filterable-->
          <!--              label="label"-->
          <!--              multiple-->
          <!--              style="width: 100%"-->
          <!--              class="dietary-select"-->
          <!--              @input="-->
          <!--                onContactInputChange(-->
          <!--                  contact.contactID,-->
          <!--                  'dietaryPreferences',-->
          <!--                  $event,-->
          <!--                )-->
          <!--              "-->
          <!--            >-->
          <!--            </v-select>-->
          <!--            <div class="note">-->
          <!--              Please select "None" if you do not have any special dietary-->
          <!--              preference.-->
          <!--            </div>-->
          <!--          </el-form-item>-->
          <el-form-item v-if="dietaryAllergiesLoaded" label="Dietary Allergies*" prop="dietaryAllergies">
            <v-select
                v-model="modelSelectedDietaryAllergies[contact.contactID]"
                :options="dietaryAllergies"
                :reduce="(item) => item.value"
                :searchable="false"
                filterable
                label="label"
                multiple
                style="width: 100%"
                class="dietary-select"
                @input="
                onContactInputChange(
                  contact.contactID,
                  'dietaryAllergies',
                  $event,
                )
              "
            >
            </v-select>
          </el-form-item>
          <el-form-item
            label="Dietary Preference Notes"
            style="margin-bottom: 40px"
          >
            <el-input
              :rows="4"
              :value="contact.dietaryPreferenceNotes"
              placeholder="Dietary Preference Notes"
              type="textarea"
              style="height: 94px"
              @input="
                onContactInputChange(
                  contact.contactID,
                  'dietaryPreferenceNotes',
                  $event,
                )
              "
            />
          </el-form-item>

          <!--          <el-form-item style="margin-bottom: 40px">-->
          <!--            <el-input-->
          <!--              :rows="4"-->
          <!--              :value="contact.dietaryAllergiesNotes"-->
          <!--              placeholder="Additional notes"-->
          <!--              type="textarea"-->
          <!--              style="height: 94px"-->
          <!--              @input="-->
          <!--                onContactInputChange(-->
          <!--                  contact.contactID,-->
          <!--                  'dietaryAllergiesNotes',-->
          <!--                  $event,-->
          <!--                )-->
          <!--              "-->
          <!--            />-->
          <!--          </el-form-item>-->
          <el-form-item label="Medical Health Notes*" prop="medicalNotes">
            <el-input
              :rows="6"
              :value="contact.medicalNotes"
              placeholder="Any medical and health conditions we should be aware of?"
              type="textarea"
              @input="
                onContactInputChange(contact.contactID, 'medicalNotes', $event)
              "
            />
            <div class="note">
              Please indicate "None" if you do not have any special medical and
              health requirements.
            </div>
          </el-form-item>

          <!--<el-row type="flex" justify="end">-->
          <!--<el-button type="text" :loading="saveDietaryPreferenceLoadings[contact.contactID]" @click="onClickSave(contact)">Save</el-button>-->
          <!--</el-row>-->
        </el-form>
      </el-collapse-item>
    </el-collapse>

    <hr />

    <h1 class="h1-title">Special Requests</h1>

    <div class="special-request">
      <el-form>
        <el-form-item label="">
          <el-input
            :rows="6"
            :value="booking.checkInRemarks"
            placeholder="Please advise of any celebrations or special requests and we will do our best to accommodate these. Our reservations executive will reach out to you to discuss further about your requests, if necessary."
            type="textarea"
            @input="onBookingInputChange('checkInRemarks', $event)"
          />
        </el-form-item>
      </el-form>
    </div>

    <div class="sticky-bottom">
      <el-row class="bottom-nav" justify="space-between" type="flex">
        <el-button
          :disabled="isSaving"
          class="button--secondary bottom-nav__secondaryButton"
          @click="onClickBack"
          >Back</el-button
        >

        <autosave-indicator></autosave-indicator>
        <el-button
          :disabled="isSaving"
          class="button--tertiary bottom-nav__secondaryButton"
          @click="onClickSaveAndExit(false)"
          >Save
        </el-button>
        <el-button
          :disabled="isSaving"
          class="button--primary bottom-nav__primaryButton"
          @click="onClickNext"
          >Next</el-button
        >
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import types from "../store/types";
import {
  DIETARY_ALLERGIES,
  DIETARY_PREFERENCES,
  FACILITY_CODES,
  UNHANDLED_ERROR_MESSAGE,
} from "../constants";
import contactMixin from "../mixins/contact";
import autosave from "../mixins/autosave";
import bookingMixin from "../mixins/booking";
import { timeTrack } from "../mixins/timeTrack";
import AutosaveIndicator from "./AutosaveIndicator";
import { waitUntil } from "../utils";

export default {
  props: {
    index: Number,
  },
  mixins: [contactMixin, bookingMixin, timeTrack, autosave],
  components: { AutosaveIndicator },
  mounted() {
    this.initializeAutosave(
      this.onClickSaveAndExit.bind(this),
      this.$refs.formRoot,
    );
  },
  created() {
    let storeDietaryAllergies = this.dietaryAllergiesFromStore;
    if (!storeDietaryAllergies || storeDietaryAllergies.length === 0) {
      this.getDietaryAllergiesData();
    } else {
      this.dietaryAllergiesLoaded = true;
    }

    gtag("set", "page_path", "/step-3");
    gtag("event", "page_path", {
      path: "/step-3",
    });

    // Initialize oldDietaryAllergies with the initial values
    this.oldDietaryAllergies = JSON.parse(JSON.stringify(this.modelSelectedDietaryAllergies));
  },
  data() {
    const contacts = this.$store.getters["contacts"];

    // Creates a local model in order for Select multiple component to work
    // actual update state is done in onContactInputChange
    // const modelSelectedDietaryPreferences = contacts.reduce(
    //     (accumulate, current) => {
    //       accumulate[current.contactID] = current.dietaryPreferences
    //           ? current.dietaryPreferences
    //           : [];
    //       return accumulate;
    //     },
    //     {},
    // );

    const modelSelectedDietaryAllergies = contacts.reduce(
        (accumulate, current) => {
          accumulate[current.contactID] = current.dietaryAllergies
              ? current.dietaryAllergies
              : [];
          return accumulate;
        },
        {},
    );

    const validationConfig = (message) => ({
      required: true,
      message: message || "Required",
      trigger: "change blur",
    });
    const ruleValidate = {
      dietaryAllergies: [validationConfig()],
      // dietaryPreferences: [
      //   validationConfig(
      //     "Please select a Dietary Preference or None if not applicable.",
      //   ),
      // ],
      medicalNotes: [
        validationConfig(
          'Please provide any relevant Medical and Health Notes or write "Not applicable" above.',
        ),
      ],
    };

    return {
      activeCollapseIndexes: this.index
        ? [this.index]
        : contacts.map((contact, index) => index),
      //selectDietaryPreferences: DIETARY_PREFERENCES,
      saveDietaryPreferenceLoadings: contacts.reduce((accumulator, current) => {
        accumulator[current.contactID] = false;
        return accumulator;
      }, {}),
      //modelSelectedDietaryPreferences,
      modelSelectedDietaryAllergies,
      ruleValidate,
      dietaryAllergiesLoaded: false,
      isUpdating: false, // Flag to prevent re-entry into the watcher
      oldDietaryAllergies: {}, // Global variable to store old values
    };
  },
  computed: {
    ...mapGetters([
      types.getters.contacts,
      types.getters.booking,
      types.getters.isSaving,
      types.getters.dietaryAllergies,
    ]),
    formElements() {
      const forms = Object.keys(this.$refs).filter((key) => key.startsWith('formValidate'))
      let results = [];
      for (const formKey of forms) {
        results.push(this.$refs[formKey][0])
      }
      return results
    },
    dietaryAllergiesFromStore() {
      return this.$store.getters["dietaryAllergies"];
    }
  },
  methods: {
    ...mapActions([
      types.actions.updateContactField,
      types.actions.updateBookingField,
      types.actions.updateContactsRemote,
      types.actions.updateContactsAndBookingRemote,
      types.actions.setIsVisibleDialogSaveAndExit,
      types.actions.getDietaryAllergies,
    ]),

    async getDietaryAllergiesData() {
      try {
        await this.getDietaryAllergies();
        this.dietaryAllergiesLoaded = true;
        this.dietaryAllergies = this.dietaryAllergiesFromStore;
      } catch (error) {
        console.log("Unable to retrieve dietary allergies from API:", error);
      }
    },

    canShowDietaryPreferenceField: function () {
      // Note: 12 July 2024 - Do not need to check for ship as we will
      // show the field in all ships to be consistent
      // As requested in the enhancements
      // return (
      //   !this.booking.isAmazonCruise &&
      //   this.booking.facilityCode !== FACILITY_CODES.AquaBlu
      // );
      return true;
    },
    handleDietaryAllergiesChange(contactID, newSelections) {
      // Convert newSelections to an array of strings if it contains objects
      const newSelectionValues = newSelections.map(item => (typeof item === 'string' ? item : item.value));
      // Get old selections and convert to array of strings
      const oldSelections = this.oldDietaryAllergies[contactID] || [];
      const oldSelectionValues = oldSelections.map(item => (typeof item === 'string' ? item : item.value));

      // Determine the added value
      const addedValues = newSelectionValues.filter(val => !oldSelectionValues.includes(val));
      const addedValue = addedValues.length > 0 ? addedValues[0] : null;
      //console.log(`[${contactID}] ADDED VALUE: `, addedValue);

      let updatedSelections = [];

      if (addedValue === 'None') {
        //console.log(`'None' added for contactID ${contactID}, retaining only 'None'.`);
        updatedSelections = ['None'];
      } else {
        updatedSelections = newSelectionValues.filter(val => val !== 'None');
      }

      // Update old selections
      this.$set(this.oldDietaryAllergies, contactID, updatedSelections);
      this.$set(this.modelSelectedDietaryAllergies, contactID, updatedSelections);

      return updatedSelections;
    },

    onContactInputChange: async function (contactID, fieldName, event) {
      console.log("[contactID, fieldName, event]", contactID, fieldName, event);
      await waitUntil(() => !this.isSaving);

      let dietaryAllergiesValues = event || [];

      if (fieldName === "dietaryAllergies") {
        dietaryAllergiesValues = this.handleDietaryAllergiesChange(contactID, dietaryAllergiesValues);
      }

      const value = fieldName === "dietaryAllergies" ? dietaryAllergiesValues : event; // With Zoho API 2.0, we can send arrays directly

      this[types.actions.updateContactField]({
        contactID,
        fieldName,
        value,
      });

      await this.validateIndividualFields(contactID, fieldName); // Validate after input change
    },
    onBookingInputChange: async function (fieldName, event) {
      console.log("[fieldName, event]", fieldName, event);
      await waitUntil(() => !this.isSaving);
      this[types.actions.updateBookingField]({
        fieldName,
        value: event,
      });
    },
    // onClickSave: function(contact) {
    //   this.saveDietaryPreferenceLoadings[contact.contactID] = true
    //   this.updateContactsRemote({ contacts: [contact], showLoader: false })
    //     .then(res => {
    //       this.$notify({
    //         title: 'Updated successfully!',
    //         type: 'success',
    //       });
    //     })
    //     .catch(error => {
    //       this.$notify.error(`${error}`);
    //     })
    //     .finally(() => {
    //       this.saveDietaryPreferenceLoadings[contact.contactID] = false
    //     })
    // },
    async onClickSaveAndExit(isAutosaving = false) {
      try {
        const res = await this.saveDataToRemote(isAutosaving);
        if (isAutosaving) {
          return res;
        } else {
          this.setIsVisibleDialogSaveAndExit(true);
        }
      } catch (error) {
        this.$message.error(error.message || UNHANDLED_ERROR_MESSAGE);
        return false;
      }

      return true;
    },
    async validateIndividualFields(contactID, fieldName) {
      const forms = Object.keys(this.$refs).filter((key) => key === 'formValidate' + contactID)
      for (const form of forms) {
        const formElement = this.$refs[form][0];
        formElement.validateField(fieldName, (response) => {
          console.log("Validated " + fieldName, response)
        })
      }
    },
    async validateForm() {
      let hasErrors = false;

      for (const item of this.formElements) {
        try {
          await item.validate(); // Wait for validation to complete
        } catch (error) {
          // Catch validation errors if they occur
          hasErrors = true;
        }
      }
      return hasErrors;
    },
    scrollToFirstError() {
      this.$nextTick(() => {
        let errorFields = [];
        for (const form of this.formElements) {
          const fields = form.fields.filter(field => field.validateState === "error")
          errorFields = errorFields.concat(fields);
        }

        if (errorFields.length > 0) {
          const firstErrorField = errorFields[0].$el;
          firstErrorField.scrollIntoView({ behavior: "smooth" });
          firstErrorField.querySelector("input").focus();
        }
      });
    },
    async onClickNext() {
      let hasErrors = await this.validateForm();

      if (hasErrors) {
        this.scrollToFirstError();
        return;
      }

      this.saveDataToRemote()
        .then((res) => {
          if (this.hasDiving()) {
            this.$router.push("step-3b");
          } else if (this.hasWetsuit()) {
            this.$router.push("step-3c");
          } else {
            this.$router.push("step-4");
          }
        })
        .catch((error) => {
          this.$message.error(error.message || UNHANDLED_ERROR_MESSAGE);
        });
    },
    onClickBack: function () {
      this.saveDataToRemote()
        .then((res) => {
          this.$router.back();
        })
        .catch((error) => {
          this.$message.error(error.message || UNHANDLED_ERROR_MESSAGE);
        });
    },
    saveDataToRemote(isAutosave = false) {
      const { contacts, booking } = this;

      // // Update contacts with the latest dietary allergies selections
      // contacts.forEach(contact => {
      //   const contactID = contact.contactID;
      //   if (this.modelSelectedDietaryAllergies[contactID]) {
      //     contact.dietaryAllergies = this.modelSelectedDietaryAllergies[contactID];
      //   }
      // });

      let emptyContactIndices = contacts
        .map((contact, index) => {
          return !contact.medicalNotes ||
            (contact.medicalNotes && contact.medicalNotes.trim().length === 0)
            ? index
            : null;
        })
        .filter((index) => index !== null);

      if (emptyContactIndices.length) {
        const guests = emptyContactIndices.map((index) => `Guest ${index + 1}`);
        const guestsText =
          guests.length <= 1
            ? guests[0]
            : `${guests.slice(0, -1).join(", ")} and ${guests.slice(-1)}`; /* convert [a,b,c] to 'a, b and c' */
        //console.log("[GUEST TEXT]", guestsText);

        if (!isAutosave) {
          console.log("PROMISE REJECTED");
          return Promise.reject({
            message: `Please select a Dietary Preference and provide Medical and Health Notes for ${guestsText}.`,
          });
        }
        return false;
      }

      return this.updateContactsAndBookingRemote({
        contacts,
        booking,
        showLoader: !isAutosave,
        workflowTrigger: !isAutosave, // let autosave push data without firing Zoho workflows
      });
    },
  },
};
</script>

<style lang="scss">
@import "../scss/color";
@import "../scss/typography";

.el-collapse-item--dietary {
  .guest-helper {
    margin-bottom: 48px;
    width: 100%;
    @include global-paragraph-small-regular;
    color: $aqua-grey-75;
  }

  .el-collapse-item {
    &__header {
      padding-left: 114px;
    }
  }

  .guest-number {
    position: absolute;
    top: 50%;
    left: 40px;
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    transform: translateY(-50%);
  }

  .el-form-item__content {
    width: 50%;
  }

  .el-select ~ .el-textarea {
    margin-top: 16px;
  }

  .el-form-item__label {
    font-size: 16px;
    font-weight: bold;
    color: $aqua-grey-100;
  }
}

.dietary-select {
  .vs__selected {
    font-weight: normal;
  }
}
</style>
<style lang="scss" scoped>
@import "../scss/color";
@import "../scss/typography";

hr {
  margin-top: 56px;
  margin-bottom: 56px;
  border-top: 1px solid $primary-color;
}

.h1-title {
  margin-bottom: 32px;
}

.special-request {
  //padding: 48px 40px;
  //background-color: #fff;

  .el-form-item__label {
    font-size: 20px;
    font-weight: normal;
    margin-bottom: 18px;
  }
}

.note {
  display: inline-block;
  margin-top: 16px;
  @include global-paragraph-medium-regular;
  color: $aqua-grey-90;
  background-color: #ecf1f5;
  padding: 6px 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/DietaryPreferenceAndSpecialRequestPage.vue